import Vue from 'vue';
import vuetify from './plugins/vuetify';
import './plugins/vuetify-dialog';
import './plugins/axios';
import router from './router';
import store from './store';
import App from './App.vue';

import '@/sass/main.scss';

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
